import { render, staticRenderFns } from "./QuotationAttachmentsTab.vue?vue&type=template&id=0d6767aa"
import script from "./QuotationAttachmentsTab.vue?vue&type=script&lang=js"
export * from "./QuotationAttachmentsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports